class WqVideoGallery extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.modal = this.querySelector('.wq-video-modal');
    this.modalVideo = this.modal?.querySelector('video');
    this.querySelectorAll('[data-wq-video-play]').forEach((button) => button.addEventListener('click', () => this.open(button)));
    this.querySelector('[data-wq-video-close]')?.addEventListener('click', () => this.close());
    this.modal?.addEventListener('click', (event) => { if (event.target === this.modal) this.close(); });
    this.observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (!entry.isIntersecting) entry.target.pause(); }), { threshold: .15 });
    this.querySelectorAll('.wq-video-card video').forEach((video) => this.observer.observe(video));
  }
  open(button) {
    const card = button.closest('.wq-video-card');
    const video = card?.querySelector('video');
    if (!video || !this.modalVideo) return;
    this.modalVideo.src = video.currentSrc || video.src;
    this.modalVideo.poster = video.poster;
    this.modalVideo.muted = false;
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wq-scroll-locked');
    this.querySelector('[data-wq-video-close]')?.focus();
    this.modalVideo.play().catch(() => {});
  }
  close() {
    this.modalVideo?.pause();
    this.modal?.classList.remove('is-open');
    this.modal?.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wq-scroll-locked');
  }
  disconnectedCallback() { this.observer?.disconnect(); }
}
if (!customElements.get('wq-video-gallery')) customElements.define('wq-video-gallery', WqVideoGallery);

